import type { CustomRequest, CustomResponse } from './model';

/**
 * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error#custom_error_types
 */
export class ApiError extends Error {
  request: CustomRequest;
  response: CustomResponse;
  constructor(message: string, request: CustomRequest, response: CustomResponse) {
    super(message);

    this.name = 'ApiError';
    this.request = request;
    this.response = response;
  }
}